import React, { useEffect, useState } from "react";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";
import { useDispatch, useSelector } from "react-redux";
import { getDetails } from "store/slices/authSlice";
import Spinners from "components/common/Spinners";

const Layout = ({ children }) => {
  const { loading } = useSelector((state) => state.Auth);
  const { isSideBarOpen } = useSelector((state) => state.CommonActions);
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const isLoggedIn = !!localStorage.getItem("authUser");
    isLoggedIn && dispatch(getDetails());

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id={`layout-wrapper ${!isSideBarOpen ? "sidebar-collapsed" : ""}`} >
      {loading ? (
        <Spinners />
      ) : (
        <>
          {isMobile && <AdminHeader />}
          <AdminSidebar  className={!isSideBarOpen ? "sidebar-collapsed" : ""}/>
          <div className="main-content">{children}</div>
        </>
      )}
    </div>
  );
};

export default Layout;